export class Rents {
  name: string;
  lastname: string;
  amount: number;
}
